// saved for later
// import config from 'config';
import {getTeam} from './mockData/MockTeamAndPlayerData'


const LOAD = 'footballteamsdetails/LOAD';
const LOAD_SUCCESS = 'footballteamsdetails/LOAD_SUCCESS';
const LOAD_FAIL = 'footballteamsdetails/LOAD_FAIL';

const initialState = {
  loaded: false
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD:
      return {
        ...state,
        [action.teamid]: {
          ...state[action.teamid],
          loading: true
        }
      };
    case LOAD_SUCCESS:
      return {
        ...state,
        [action.teamid]: {
          ...state[action.teamid],
          loading: false,
          loaded: true,
          details: action.result
        }
      };
    case LOAD_FAIL:
      return {
        ...state,
        [action.teamid]: {
          ...state[action.teamid],
          loading: false,
          loaded: false,
          error: action.error
        }
      };
    default:
      return state;
  }
}

export function isLoading(globalState, teamid) {
  return globalState.football
      && globalState.football.teamDetails
      && globalState.football.teamDetails[teamid]
      && globalState.football.teamDetails[teamid].loading;
}

export function load(teamid) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    // saved for later
    // promise: (client) => client.get(`${config.api.football.vidiprinter}`)
    promise: () => {
      const {id, name, urlSlug} = getTeam(teamid);
      return Promise.resolve({id, name, urlSlug});
    },
    teamid
  };
}



// WEBPACK FOOTER //
// ./modules/Football/reducers/teamDetails.js